export default IconTransactionYen => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-transaction-yen" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M15 16h6" />
  <path d="M15 12l3 4.5" />
  <path d="M21 12l-3 4.5v4.5" />
  <path d="M15 19h6" />
  <path d="M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
  <path d="M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
  <path d="M7 5h8" />
  <path d="M7 5v8a3 3 0 0 0 3 3h1" />
</svg>`;